import { gql } from '@apollo/client'

export default gql(`
query listMetaSections($filter: ListMetaSectionsFilterInput){
    listMetaSections( 
        filter: $filter
    ){
        items{
            id
            title
            usedCount
            }
        }
    }
`)
